/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net Command API
 * OpenAPI spec version: v1
 */
import {
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  FleetInventories,
  FleetInventoriesParams,
  FleetInventory,
  FleetInventoryItem,
  FleetInventoryItems,
  FleetInventoryItemsParams,
  SchemaValidationErrorResponse,
  StandardError
} from '../../models';

import { axiosClient } from '../../../axiosAdminClient.ts';
import type { ErrorType } from '../../../axiosAdminClient.ts';




/**
 * @summary Fleet Inventories list
 */
export const fleetInventories = (
    fleetId: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetInventoriesParams>,
 signal?: AbortSignal
) => {
      fleetId = toValue(fleetId);
params = toValue(params);

      return axiosClient<FleetInventories>(
      {url: `/fleets/${fleetId}/inventories`, method: 'GET',
        params, signal
    },
      );
    }




export const getFleetInventoriesQueryKey = (fleetId: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetInventoriesParams>,) => {
    return [
    'fleets',fleetId,'inventories', ...(params ? [params] : [])
    ] as const;
    }


export const getFleetInventoriesQueryOptions = <TData = Awaited<ReturnType<typeof fleetInventories>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(fleetId: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetInventoriesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetInventories>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getFleetInventoriesQueryKey(fleetId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof fleetInventories>>> = ({ signal }) => fleetInventories(fleetId,params, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(fleetId) !== null && toValue(fleetId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fleetInventories>>, TError, TData>
}

export type FleetInventoriesQueryResult = NonNullable<Awaited<ReturnType<typeof fleetInventories>>>
export type FleetInventoriesQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Fleet Inventories list
 */

export function useFleetInventories<TData = Awaited<ReturnType<typeof fleetInventories>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 fleetId: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetInventoriesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetInventories>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFleetInventoriesQueryOptions(fleetId,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Fleet Inventory Items list
 */
export const fleetInventoryItems = (
    fleetId: MaybeRefOrGetter<string>,
    fleetInventoryId: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetInventoryItemsParams>,
 signal?: AbortSignal
) => {
      fleetId = toValue(fleetId);
fleetInventoryId = toValue(fleetInventoryId);
params = toValue(params);

      return axiosClient<FleetInventoryItems>(
      {url: `/fleets/${fleetId}/inventories/${fleetInventoryId}/items`, method: 'GET',
        params, signal
    },
      );
    }




export const getFleetInventoryItemsQueryKey = (fleetId: MaybeRefOrGetter<string>,
    fleetInventoryId: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetInventoryItemsParams>,) => {
    return [
    'fleets',fleetId,'inventories',fleetInventoryId,'items', ...(params ? [params] : [])
    ] as const;
    }


export const getFleetInventoryItemsQueryOptions = <TData = Awaited<ReturnType<typeof fleetInventoryItems>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(fleetId: MaybeRefOrGetter<string>,
    fleetInventoryId: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetInventoryItemsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetInventoryItems>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getFleetInventoryItemsQueryKey(fleetId,fleetInventoryId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof fleetInventoryItems>>> = ({ signal }) => fleetInventoryItems(fleetId,fleetInventoryId,params, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(fleetId) !== null && toValue(fleetId) !== undefined && toValue(fleetInventoryId) !== null && toValue(fleetInventoryId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fleetInventoryItems>>, TError, TData>
}

export type FleetInventoryItemsQueryResult = NonNullable<Awaited<ReturnType<typeof fleetInventoryItems>>>
export type FleetInventoryItemsQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Fleet Inventory Items list
 */

export function useFleetInventoryItems<TData = Awaited<ReturnType<typeof fleetInventoryItems>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 fleetId: MaybeRefOrGetter<string>,
    fleetInventoryId: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetInventoryItemsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetInventoryItems>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFleetInventoryItemsQueryOptions(fleetId,fleetInventoryId,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary One fleet inventory item
 */
export const fleetInventoryItem = (
    fleetId: MaybeRefOrGetter<string>,
    fleetInventoryId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetId = toValue(fleetId);
fleetInventoryId = toValue(fleetInventoryId);
id = toValue(id);

      return axiosClient<FleetInventoryItem>(
      {url: `/fleets/${fleetId}/inventories/${fleetInventoryId}/items/${id}`, method: 'GET', signal
    },
      );
    }




export const getFleetInventoryItemQueryKey = (fleetId: MaybeRefOrGetter<string>,
    fleetInventoryId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,) => {
    return [
    'fleets',fleetId,'inventories',fleetInventoryId,'items',id
    ] as const;
    }


export const getFleetInventoryItemQueryOptions = <TData = Awaited<ReturnType<typeof fleetInventoryItem>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(fleetId: MaybeRefOrGetter<string>,
    fleetInventoryId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetInventoryItem>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getFleetInventoryItemQueryKey(fleetId,fleetInventoryId,id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof fleetInventoryItem>>> = ({ signal }) => fleetInventoryItem(fleetId,fleetInventoryId,id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(fleetId) !== null && toValue(fleetId) !== undefined && toValue(fleetInventoryId) !== null && toValue(fleetInventoryId) !== undefined && toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fleetInventoryItem>>, TError, TData>
}

export type FleetInventoryItemQueryResult = NonNullable<Awaited<ReturnType<typeof fleetInventoryItem>>>
export type FleetInventoryItemQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary One fleet inventory item
 */

export function useFleetInventoryItem<TData = Awaited<ReturnType<typeof fleetInventoryItem>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 fleetId: MaybeRefOrGetter<string>,
    fleetInventoryId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetInventoryItem>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFleetInventoryItemQueryOptions(fleetId,fleetInventoryId,id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary One fleet inventory
 */
export const fleetInventory = (
    fleetId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetId = toValue(fleetId);
id = toValue(id);

      return axiosClient<FleetInventory>(
      {url: `/fleets/${fleetId}/inventories/${id}`, method: 'GET', signal
    },
      );
    }




export const getFleetInventoryQueryKey = (fleetId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,) => {
    return [
    'fleets',fleetId,'inventories',id
    ] as const;
    }


export const getFleetInventoryQueryOptions = <TData = Awaited<ReturnType<typeof fleetInventory>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(fleetId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetInventory>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getFleetInventoryQueryKey(fleetId,id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof fleetInventory>>> = ({ signal }) => fleetInventory(fleetId,id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(fleetId) !== null && toValue(fleetId) !== undefined && toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fleetInventory>>, TError, TData>
}

export type FleetInventoryQueryResult = NonNullable<Awaited<ReturnType<typeof fleetInventory>>>
export type FleetInventoryQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary One fleet inventory
 */

export function useFleetInventory<TData = Awaited<ReturnType<typeof fleetInventory>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 fleetId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetInventory>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFleetInventoryQueryOptions(fleetId,id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






